// actions.js
export const INIT_LIBRARY_REQUEST = 'INIT_REPORT_REQUEST';
export const ADD_LIBRARY = 'ADD_REPORT';
export const ERROR_LIBRARY_REQUEST = 'ERROR_REPORT_REQUEST';
export const ERROR_ADD_LIBRARY_REQUEST = 'ERROR_REPORT_REQUEST';


// actions.js
export function initLibraryRequest() {
    return { type: INIT_LIBRARY_REQUEST };
}

export function addLibrary(data) {
    return { type: ADD_LIBRARY, payload: data };
}

export function errorLibraryRequest(error) {
    return { type: ERROR_LIBRARY_REQUEST, payload: error };
}

export function errorAddLibraryRequest(error) {
    return { type: ERROR_ADD_LIBRARY_REQUEST, payload: error };
}
